import { NavLink } from 'react-router-dom';
import { NAV_ITEMS, ROUTES } from '@/app/routes';
import { NAV_ICONS } from '@/components/icons';
import { cn } from '@/lib/cn';
import { NavAttention } from './ActionBanner';
import { Brand } from './Brand';
import { useNotifications } from './notification-context';

/**
 * Persistent desktop navigation. Hidden below the `lg` breakpoint.
 *
 * Pinned to the viewport rather than the document: the nav is a fixed set of
 * destinations, so scrolling a long screen should not carry it out of reach.
 * `sticky` keeps it in the flex row — `fixed` would take it out of flow and
 * leave the main column to slide underneath.
 */
export function Sidebar() {
  const { inbox } = useNotifications();

  return (
    <aside className="sticky top-0 hidden h-dvh w-[210px] shrink-0 flex-col overflow-y-auto border-r border-border bg-canvas/60 px-4.5 pb-6 pt-10 lg:flex">
      <Brand className="mb-8 px-2" />

      <nav aria-label="Main" className="flex flex-col gap-1">
        {NAV_ITEMS.map((item) => {
          const Icon = NAV_ICONS[item.icon];

          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2.5 rounded-control px-3 py-2.5 text-xs font-bold transition',
                  isActive
                    ? 'border border-primary/20 bg-primary-muted text-primary'
                    : 'border border-transparent text-content-muted hover:bg-white/5 hover:text-content',
                )
              }
            >
              <span className="relative">
                <Icon className="size-5 shrink-0" />
                <NavAttention
                  on={
                    (item.to === ROUTES.team && inbox?.nav.team) ||
                    (item.to === ROUTES.contests && inbox?.nav.contests) ||
                    false
                  }
                />
              </span>
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      <p className="mt-auto pt-6 font-mono text-[10px] uppercase leading-relaxed tracking-[0.1em] text-content-muted">
        Fantasy / 2026
        <br />
        Premier League
      </p>
    </aside>
  );
}
